// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { AbstractSimpleModuleUi, abstractSimpleModuleUiOptions } from '../_abstract/ui'

import { BlockquoteModule } from './Blockquote.contracts'

/**
 * Component capable of rendering the `BlockquoteModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({ ...abstractSimpleModuleUiOptions, name: 'BlockquoteModuleUi' })
export class BlockquoteModuleUi extends AbstractSimpleModuleUi<BlockquoteModule> {}
